var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id,attrs:{"sm":"6","md":"4","lg":"3","cols":"12"}},[_c('UserCard',{attrs:{"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }